import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const MAX_LENGTH = 200;

const SectionAuthorProfileDesciption = props => {
  const {
    listing,
    description
  } = props;

  if (!listing.author) {
    return null;
  }

  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = description.length > MAX_LENGTH;
  const displayedText = isExpanded || !shouldTruncate
    ? description
    : description.slice(0, MAX_LENGTH) + '...';

  const toggleExpanded = () => setIsExpanded(prev => !prev);

  return (
    <div className={css.sectionProfileText}>
      <Heading as="h2" rootClassName={css.sectionProfileHeading}>
        <FormattedMessage id="ListingPage.aboutMe" />
      </Heading>
      <p className={css.sectionProfileDescription}>
        {displayedText}
        {shouldTruncate && !isExpanded && (
          <span
            className={css.seeMoreButton}
            onClick={toggleExpanded}
          >
            <FormattedMessage id="ListingPage.seeMore" />
          </span>
        )}
        {isExpanded && (
          <span
            className={css.seeMoreButton}
            onClick={toggleExpanded}
          >
            <FormattedMessage id="ListingPage.seeLess" />
          </span>
        )}
      </p>
    </div>
  );
};

export default SectionAuthorProfileDesciption;
